module.exports = __webpack_public_path__ + "img/A_info.b02dfe60.png";